import { render, staticRenderFns } from "./AcompanhamentoAcaoApuracao.vue?vue&type=template&id=9a9245d8&lang=html"
import script from "./AcompanhamentoAcaoApuracao.vue?vue&type=script&lang=js"
export * from "./AcompanhamentoAcaoApuracao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports